<template>

  <div>
    <md-table xv-model="ordiniScarico" md-card @md-selected="onSelect">
      <md-toolbar class="md-primary">
        <h3 class="md-title" style="flex: 1">Ordini di scarico</h3>
        <!--md-button class="md-icon-button" to="/scarico/upload">
            <md-icon>upload</md-icon>
          </md-button-->
        <md-button class="md-icon-button" to="/scarico/nuovo">
            <md-icon>add</md-icon>
        </md-button>
        <md-button class="md-icon-button" @click="exportData()">
            <md-icon>file_download</md-icon>
        </md-button>
        <downloadCsv v-if="null != jsonData" :data="jsonData" name="scarico.csv" style="display:none" ref="dlBtn"></downloadCsv>
      </md-toolbar>
      <ScaricoFiltri v-on:ricerca-ordini-scarico="fetchData" style="margin-bottom: 20px;"></ScaricoFiltri>
      <md-table class="fullScreen">
        <md-table-row class="tableHeader">
          <md-table-head class="status">&nbsp;</md-table-head>
          <md-table-head>Delivery Note</md-table-head>
          <md-table-head>Date</md-table-head>
          <md-table-head>Elogate</md-table-head>
          <md-table-head>Transport mean</md-table-head>
          <md-table-head>POS</md-table-head>
          <md-table-head>CMR</md-table-head>
          <md-table-head>SAP</md-table-head>
          <md-table-head>Magazzino</md-table-head>
          <!--<md-table-head>Gross weight</md-table-head>
          <md-table-head>Net weight</md-table-head -->
          <md-table-head class="action">&nbsp;</md-table-head>
        </md-table-row>
        <template v-for="row in ordiniScarico">
              <md-table-row :key="row.id" :class="{'scaricato' : row.scaricato, 'incomplete' : row.incomplete}">
                <md-table-cell class="status"><md-icon v-show="row.scaricato">task_alt</md-icon></md-table-cell>
                <md-table-cell>{{row.deliveryNote}}</md-table-cell>
                <md-table-cell>{{row.orderDate}}</md-table-cell>
                <md-table-cell>{{row.elogate}}</md-table-cell>
                <md-table-cell>{{row.transportMean}}</md-table-cell>
                <md-table-cell>{{row.pos}}</md-table-cell>
                <md-table-cell>{{row.cmr}}</md-table-cell>
                <md-table-cell>{{row.sap}}</md-table-cell>
                <md-table-cell>{{row.depot}}</md-table-cell>
                <!--<md-table-cell>{{row.grossWeight.quantity}} / {{row.grossWeight.unit}}</md-table-cell>
                <md-table-cell>{{row.netWeight.quantity}} / {{row.netWeight.unit}}</md-table-cell -->
                <md-table-cell>
                  <div class="action-align">
                    <md-button class="md-icon-button" @click="scaricato(row)">
                      <md-icon>local_shipping</md-icon>
                    </md-button>
                    <md-button class="md-icon-button"  @click="viewBarcodes(row)">
                      <md-icon>qr_code_2</md-icon>
                    </md-button>
                    <md-button class="md-icon-button" @click="onEditRow(row)" :disabled="row.scaricato">
                      <md-icon>edit</md-icon>
                    </md-button>
                    <md-button class="md-icon-button" @click="onDeleteRow(row)" :disabled="row.scaricato">
                      <md-icon>delete</md-icon>
                    </md-button>
                    <md-button class="md-button" @click="viewPdf(row.id,1)" v-show="row.documenti.carico.uploaded">
                      <md-icon>picture_as_pdf</md-icon> Carico
                    </md-button>
                    <md-button class="md-button" @click="viewPdf(row.id,2)" v-show="row.documenti.scarico.uploaded">
                      <md-icon>picture_as_pdf</md-icon> Scarico
                    </md-button>
                  </div>
                </md-table-cell>
              </md-table-row>
            </template>
      </md-table>
    </md-table>
    <md-card>
      <md-card-content>
          <div class="pager">
            <md-button class="md-icon-button" @click="prev()" :disabled="pager.page == 1" v-bind:class="{'md-raised' : pager.page > 1}">
              <md-icon>navigate_before</md-icon>
            </md-button>
            <div class="current">Pag. {{pager.page}}/{{pager.max}}</div>
            <md-button class="md-icon-button" @click="next()" :disabled="pager.page >= pager.max" v-bind:class="{'md-raised' : pager.page < pager.max}">
              <md-icon>navigate_next</md-icon>
            </md-button>
          </div>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import ScaricoFiltri from './ScaricoFiltri.vue'

export default {
  name: 'Scarico',
  data: () => ({
    ordiniScarico: [],
    filtri : {},
    jsonData : null,
    pager: {
      page : 1,
      max : 1
    }
  }),
  components: {
    ScaricoFiltri
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    next() {
      this.pager.page = Math.min(++this.pager.page, this.pager.max)
      this.fetchData(this.filtri)
    },
    exportData(){
      let loading = this.$loading.show();
      this.$http
        .post(
          '/data/scarico',
          { action: 'export', filters: this.filtri },
          { headers: { Authorization: 'Bearer ' + this.$cookie.get('token') } }
        )  .then(response => {
          this.jsonData = response.data.data
        })  .then(() => {
          this.$refs.dlBtn.$el.click()
          loading.hide()
        })
    },
    scaricato(row) {
      if (!row.scaricato) {
          this.doScaricato(row);
      } else {
        this.$fire({
          title: 'Attenzione!',
          html: "L\'ordine &egrave; gi&agrave; stato inviato, sei sicuro di voler sbloccate l\'ordine?",
          type: 'warning',
          showCancelButton: true,
          cancelButtonText: 'No',
          confirmButtonColor: '#3085d6',
          // cancelButtonColor: '#d33',
          confirmButtonText: 'Si, sono sicuro'
        }).then(result => {
          if (result.value) {
              this.doScaricato(row);
          }
        })
      }
    },
    doScaricato(row) {
      this.$http
        .post(
          '/data/scarico',
          { action: 'scaricato',  id: row.id , scaricato : !row.scaricato},
          { headers: { Authorization: 'Bearer ' + this.$cookie.get('token') } }
        )
        .then(deleteResponse => {
          if (deleteResponse.data.done) {
            row.scaricato = !row.scaricato
          } else {
            this.$fire({
              html: deleteResponse.data.message,
              type: 'error'
            })
          }
        })
    },
    viewPdf(id,type){
      window.open("/data/view-scarico-pdf?id=" + id + "&type=" + type, "_blank", "toolbar=yes,scrollbars=yes,resizable=yes")
    },
    prev() {
      this.pager.page = Math.max(--this.pager.page, 1)
      this.fetchData(this.filtri)
    },
    viewBarcodes(item) {
      this.$router.push({ path: '/scarico/barcode/' + item.id })
    },
    onEditRow(item) {
      this.$router.push({ path: '/scarico/edit/' + item.id })
    },
    onDeleteRow(item) {
      this.$fire({
        title: 'Sei sicuro?',
        html: "Non sar&agrave; possibile annullare l'operazione",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Annulla',
        confirmButtonColor: '#3085d6',
        // cancelButtonColor: '#d33',
        confirmButtonText: 'Cancella'
      }).then(result => {
        if (result.value) {
          this.$http
            .post(
              '/data/scarico',
              { action: 'delete', what : 'head', id: item.id },
              { headers: { Authorization: 'Bearer ' + this.$cookie.get('token') } }
            )
            .then(deleteResponse => {
              if (deleteResponse.data.done) {
                this.$fire({
                  title: 'Cancellato!',
                  html: "L'ordine di scarico &egrave; stato cancellato",
                  type: 'success'
                }).then(r => {
                  this.fetchData(this.filtri)
                })
              } else {
                this.$fire({
                  html: deleteResponse.data.message,
                  type: 'error'
                }).then(r => {
                  if (response.data.bu != '') this.$router.push(response.data.bu)
                })
              }
            })
        }
      })
    },
    async fetchData(filtri) {
      if (filtri) this.filtri = filtri
      if (this.filtri.reset) {
        this.pager =  {
          page : 1,
          max : 1
        }
      }
      let loading = this.$loading.show();
      try {
        const params = { action: 'list' , filters : this.filtri, page : this.pager.page}
        const response = await this.$http.post('/data/scarico', params, {
          headers: { Authorization: 'Bearer ' + this.$cookie.get('token') }
        })
        loading.hide()
        if (!response.data.done) {
          this.pager =  {
              page : 1,
              max : 1
          }
          this.$fire({
            html: response.data.message,
            type: 'error'
          }).then(r => {
            if (response.data.bu != '') this.$router.push(response.data.bu)
          })
          return
        }
//        this.ordiniScarico = [];
//        setTimeout(function () {
            this.ordiniScarico = response.data.data;
//        }, 1000);
        this.pager = response.data.pager
      } catch (err) {
        loading.hide()
        if (err.response) {
          this.$fire({
            text: 'Server error: ' + err,
            type: 'error'
          })
        } else if (err.request) {
          this.$fire({
            text: 'Network error: ' + err,
            type: 'error'
          })
        } else {
          this.$fire({
            text: 'System error: ' + err,
            type: 'error'
          })
        }
      }
    }
  }
}

</script>

<style lang="css" scoped>

.md-table + .md-table {
  margin-top: 16px;
}
.md-button.md-theme-default[disabled] {
    opacity:0.4;
}
.action-align{
  display: flex;
  align-items: baseline;
}
</style>



// WEBPACK FOOTER //
// src/components/Scarico.vue